import Vue from 'vue'

import {
  Vuetify,
  VAlert,
  VCalendar,
  VSheet,
  VApp,
  VCarousel,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VForm,
  VTextField,
  VCheckbox,
  VTextarea,
  VTooltip,
  VTimePicker,
  VDatePicker,
  VMenu,
  VSelect,
  VDivider,
  VDataTable,
  VDialog,
  VCard,
  VBadge,
  VSnackbar,
  VAvatar,
  VImg,
  transitions,
  VTabs
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VCarousel,
    VCalendar,
    VSheet,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VForm,
    VTextField,
    VCheckbox,
    VTextarea,
    VTooltip,
    VTimePicker,
    VDatePicker,
    VMenu,
    VSelect,
    VDivider,
    VDataTable,
    VDialog,
    VCard,
    VBadge,
    VSnackbar,
    VAvatar,
    transitions,
    VImg,
    VTabs
  },
  theme: {
    primary: '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#1867c0',
    alternate: '#2196F3',
    success: '#4CAF50',
    warning: '#F77D02'
  },
  customProperties: true,
  iconfont: 'md' || 'fa',
})
